export default __webpack_public_path__ + "static/media/background-olso-1.b20cbf7b.jpg";